import { Pipe, PipeTransform } from '@angular/core';
import { amountToWords } from '../utils/number-to-words';

@Pipe({
  name: 'amountInWords',
  standalone: true
})
export class AmountInWordsPipe implements PipeTransform {
  transform(
    value: number | string | null | undefined,
    currency: string = 'XOF'
  ): string {
    if (value === null || value === undefined) return '';
    const amount = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(amount)) return '';

    return amountToWords(amount, currency);
  }
}
